export default {
  myTrainingDetail_submit__num: '共{voteQuantity}人提交',
  myTrainingDetail_teacher_score:'讲师评分：{teacherScore}分',
  myTrainingDetail_content_score:'内容评分：{contentScore}分',
  myTrainingDetail_organization_score:'组织评分：{organizationScore}分',
  myTrainingDetail_check_schedule:'1304Web-查看日程表',
  myTrainingDetail_no_schedule:'还没有日程表',
  myTrainingDetail_date_schedule:'第{i}天',
  myTrainingDetail_teacher:'讲师：',
  myTrainingDetail_cancel_registration:'取消报名',
  myTrainingDetail_cancel_reason:'请输入取消报名原因',
  myTrainingDetail_submit_comment1308:'1308Web-提交讨论',
  myTrainingDetail_all_course:'全部课程',
  myTrainingDetail_open_time:'开课时间：',
  myTrainingDetail_address_class:'班级地点：',
  myTrainingDetail_lecturer:'讲师：  ',
  myTrainingDetail_student_number:'等{studentNumber}人参加该面授班',
  myTrainingDetail_no_student_join:'没有人报名参与该面授班',
  myTrainingDetail_student_join_num:'{studentNumber}人参加该面授班',
  myTrainingDetail_reported_limited:'已报/限报：',
  myTrainingDetail_registration_deadline:"距离报名截止还有",
  myTrainingDetail_failed_apply_reapply:'报名申请未通过，是否重新报名',
  myTrainingDetail_failed_reason:'未通过原因：',
  myTrainingDetail_registration_start:'距离报名开始还有：',
  myTrainingDetail_registration_no_start:'报名未开始',
  myTrainingDetail_I_sign_up:'我要报名',
  myTrainingDetail_full_registration:"已报满",
  myTrainingDetail_registration_ended:'报名截止',
  myTrainingDetail_re_apply:'重新报名',
  myTrainingDetail_registration_review:'报名审核中',
  myTrainingDetail_concell_registration_review:'取消报名审核中',
  myTrainingDetail_congratulations_graduation:'恭喜你毕业啦',
  myTrainingDetail_I_want_evaluate:'我要评价',
  myTrainingDetail_check_resources1312:'1312Web-查看资源',
  myTrainingDetail_remain_quantity:'你还有{remainQuantity}次考试机会',
  myTrainingDetail_check_all1311:'1311Web-查看全部',
  myTrainingDetail_total_exam:'全部考试',
  myTrainingDetail_no_graduation_path:'后台错误，找不到毕业纪念册路径',
  myTrainingDetail_check_graduation1313:'1313Web-查看毕业纪念册',
  myTrainingDetail_faceclass13:'13Web-面授班',
  myTrainingDetail_look_graduation_album:'快来看看你的毕业纪念册！',
  myTrainingDetail_graduation_album:"毕业纪念册",
  myTrainingDetail_browser_not_support:'您的浏览器不支持浏览毕业纪念册',
  myTrainingDetail_no_permission_view:'您没有查看权限',
  myTrainingDetail_images:'图片',
  myTrainingDetail_files_type:'仅支持上传格式为：word、excel、ppt、pdf、jpg、png的附件',
  myTrainingDetail_files_upload_limit:'上传不超过5个附件',
  myTrainingDetail_files_size_limit:'文件 {fileObj} 大小超过20M，请重新上传',
  myTrainingDetail_files_empty_limit:'文件内容不可以为空',
  myTrainingDetail_files_value_limit:'最多输入10000字',
  myTrainingDetail_enclosure:'附件：',
  myTrainingDetail_select:'选择',
  myTrainingDetail_file_upload_limits:'（可上传不超过5个附件，格式支持：word、excel、ppt、pdf、jpg、png，每个文件大小为20M以内。）',
  myTrainingDetail_all_live:'全部直播',
  myTrainingDetail_Live_time:"直播时间：",
  myTrainingDetail_anchor_name:'主播：',
  myTrainingDetail_all_questionnaires:'全部问卷',
  myTrainingDetail_no_honor_list:'还没有荣誉榜',
  myTrainingDetail_submit_comment1303:'1303Web-提交评价',
  myTrainingDetail_go_comment_pages:'1302Web-进入评价页',
  myTrainingDetail_submit_comment:'提交评价',
  myTrainingDetail_face_class_comment:'面授班评价',
  myTrainingDetail_please_comment:'请对该面授班进行评价',
  myTrainingDetail_Instructor_rating:'讲师评分',
  myTrainingDetail_content_rating:'内容评分',
  myTrainingDetail_org_rating:"组织评分",
  myTrainingDetail_rate_placeholder:"写一些对班级的评价吧 (选填)",
  myTrainingDetail_my_rate:'我的评价:',
  myTrainingDetail_submit_success:'提交评价成功',
  myTrainingDetail_make_online_courses:"制作在线课程",
  myTrainingDetail_individual:"个",
  myTrainingDetail_Live_broadcast:'主播直播',
  myTrainingDetail_face_class_teach:'面授班授课',
  myTrainingDetail_my_lecture_overview:'我的授课概览',
  myTrainingDetail_no_learn_resource:'你没有创建过学习资源',
  myTrainingDetail_my_live_broadcast:'我主播的直播',
  myTrainingDetail_my_teach_faceclass:'我授课的面授班',
  myTrainingDetail_deadline:'距离报名截止还有：',
  myTrainingDetail_upload:'上传附件：',
  myTrainingDetail_voteQuantity:'共{voteQuantity}人提交',
  myTrainingDetail_teacherScore:'讲师评分：{teacherScore}分',
  myTrainingDetailcontentScore:'内容评分：{contentScore}分',
  myTrainingDetail_organizationScore:'组织评分：{organizationScore}分 ',
  myTrainingDetail_score:'{score}分',
}
